module.exports = __webpack_public_path__ + "img/book8.f2e7bd48.jpg";